<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Yg039m/images/cover.jpg?1685327250539" alt="This image is the cover for the book Disagreeing Virtuously"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Disagreeing Virtuously
      </h1>
      <p class="bookDescription body article font2">
        <p>Disagreement is inevitable, particularly in our current context, marked by the close coexistence of conflicting values and perspectives in politics, religion, and ethics. How can we deal with disagreement ethically and constructively in our pluralistic world?<br/><br/> In <i>Disagreeing Virtuously</i> Olli-Pekka Vainio presents a valuable interdisciplinary approach to that question, drawing on insights from intellectual history, the cognitive sciences, philosophy of religion, and virtue theory. After mapping the current discussion on disagreement among various disciplines, Vainio offers fresh ways to understand the complicated nature of human disagreement and recommends ways to manage our interpersonal and intercommunal conflicts in ethically sustainable ways.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Olli-Pekka Vainio, Rob Barrett
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5a0eb418